var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "手动设置进货网",
        visible: _vm.dialogVisible,
        width: "500px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "max-height": "50vh",
            "overflow-y": "auto",
            padding: "15px 30px",
            "background-color": "#f6f6f6"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员编号" } },
                [
                  _c("el-input", {
                    on: { input: _vm.onNumberChange },
                    model: {
                      value: _vm.form.number,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "number", $$v)
                      },
                      expression: "form.number"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "会员姓名" } },
                [_c("el-input", { attrs: { value: _vm.form.real_name } })],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "原进货网" } },
                [_c("el-input", { attrs: { value: _vm.form.before_direct } })],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "原进货网等级" } },
                [
                  _c("el-input", {
                    attrs: { value: _vm.form.before_direct_grade }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新进货网" } },
                [
                  _c("el-input", {
                    on: { input: _vm.onDirectChange },
                    model: {
                      value: _vm.form.after_direct,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "after_direct", $$v)
                      },
                      expression: "form.after_direct"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新进货网等级" } },
                [
                  _c("el-input", {
                    attrs: { value: _vm.form.after_direct_grade }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }